import { FindMotors } from './FindMotors'
import { NationalHeritageBoard } from './NationalHeritageBoard'
import { RoadAdministration } from './RoadAdministration'

export const Projects = {
  FindMotors: FindMotors,
  NationalHeritageBoard: NationalHeritageBoard,
  RoadAdministration: RoadAdministration
}
